export default "__VITE_ASSET__BweOuOqt__"